import requestMixin from "../Common/requestMixin";

function gatherCustomFieldsToSend() {
    const customFields = {};

    const marketingOverPhone = document.querySelector("#marketingViaPhone") as HTMLInputElement;
    const marketingOverEmail = document.querySelector("#marketingViaEmail") as HTMLInputElement;

    if (marketingOverPhone?.checked) {
        customFields["marketingOverPhone"] = true;
    }
    if (marketingOverEmail?.checked) {
        customFields["marketingOverEmail"] = true;
    }

    return customFields;
}

window.addEventListener("load", function () {
    const regulationsUpdateModal = document.querySelector("#regulationsUpdateModal");
    const regulationsOkButton = document.querySelector("#regulationsOkButton");

    if (!regulationsOkButton) {
        return;
    }
    if (!regulationsUpdateModal) {
        return;
    }

    regulationsOkButton.addEventListener("click", function () {
        regulationsOkButton.classList.add("is-loading");

        requestMixin.methods
            .promiseRequest({
                url: `/api/users/regulation-consents`,
                method: "post",
                json: gatherCustomFieldsToSend(),
            })
            .then(res => {
                regulationsUpdateModal.classList.remove("is-active");
                regulationsOkButton.classList.remove("is-loading");

                if (res.statusCode !== 204) {
                    alert("Error: Could not confirm regulation consents update.");
                }
            });
    });

    //handling v4
    const marketingSelectAll = document.querySelector("#marketingSelectAll");
    const marketingViaPhone = <HTMLInputElement | null>document.querySelector("#marketingViaPhone");
    const marketingViaEmail = <HTMLInputElement | null>document.querySelector("#marketingViaEmail");

    if (marketingSelectAll && marketingViaPhone && marketingViaEmail) {
        marketingSelectAll.addEventListener("click", () => {
            marketingViaPhone.checked = true;
            marketingViaEmail.checked = true;
        });
    }
});
